import { EntityType } from "../../../../models";
import { DeleteObjectsActions, DeleteObjectsStore } from "../../../flux/DeleteObjects";
import { DeleteObjectsFn, DeleteObjectsRequest } from "../../../../rest/DeleteObjects";
import { assertArray, assertTrue } from "../../../utils/assert";
import { ListActions } from "../../../flux/Grid";
import { Command } from "../../../../Command";

// This command is executed from UI when we want to delete single or multiple entities
export class DeleteObjectsCommand implements Command
{
    private readonly delObjActions = new DeleteObjectsActions();
    private readonly listStoreActions = new ListActions();
    
    constructor(private entityType: EntityType, private store: DeleteObjectsStore, private deleteObjects: DeleteObjectsFn)
    {
    }

    execute = () => {
        const { ids } = this.store.getState();
        assertArray(ids);
        assertTrue(ids.length > 0);
        
        const request: DeleteObjectsRequest = {
            [EntityType[this.entityType]]: ids
        };

        this.deleteObjects(request)
            .then(res => {
                if(res.Success) {
                    this.delObjActions.setIds([], this.entityType);
                    this.delObjActions.hideConfirmation(this.entityType);
                    this.listStoreActions.removeItems(ids, this.entityType);
                } else {
                    this.delObjActions.showError(new Error(res.ErrorMessage), this.entityType);
                }
            })
            .catch(err => {
                this.delObjActions.showError(err, this.entityType);
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/commands/DeleteObjects.ts